/**
 * Domain enumerations. These values are mirrored 1:1 by PostgreSQL enum types
 * (see apps/api/src/db/migrations/0001_init.sql) — keep both in sync.
 */
export const USER_ROLES = ['admin', 'qa_lead', 'qa_engineer', 'analyst', 'viewer'];
export const PROJECT_STATUSES = ['active', 'archived'];
/**
 * What a folder holds. Test cases and checklists each have their own tree
 * inside a project: a folder never mixes the two.
 */
export const FOLDER_KINDS = ['case', 'checklist', 'run'];
/**
 * The two reference lists a test case classifies itself with, beyond labels
 * and environments: which layer of the system it exercises (UI, API) and which
 * functional module it belongs to. Both are per-project catalogues, so one
 * table holds them and this tells the rows apart.
 */
export const CASE_ATTRIBUTE_KINDS = ['layer', 'module'];
export const CASE_PRIORITIES = ['low', 'medium', 'high', 'critical'];
export const CASE_SEVERITIES = ['trivial', 'minor', 'major', 'critical', 'blocker'];
export const CASE_STATUSES = ['draft', 'active', 'deprecated'];
export const RUN_STATUSES = ['active', 'completed', 'aborted'];
export const RUN_ITEM_STATUSES = ['not_run', 'passed', 'failed', 'blocked', 'skipped'];
/**
 * Statuses that count as "executed" when computing run progress.
 *
 * Human-readable labels for these enums are not defined here: they are
 * presentation and belong to the interface's dictionaries (apps/web/src/i18n),
 * which have one set per language.
 */
export const EXECUTED_RUN_ITEM_STATUSES = ['passed', 'failed', 'blocked', 'skipped'];
/**
 * Label colours. A fixed palette rather than free-form hex: labels stay
 * readable in both themes, and the interface can map each name onto its own
 * token pair (text + tinted background).
 */
export const LABEL_COLORS = ['gray', 'blue', 'green', 'amber', 'red', 'purple'];
/** The same palette tints a project's icon: one set of tokens, two uses. */
export const PROJECT_ICON_COLORS = LABEL_COLORS;
/**
 * The icons a project can be given — a fixed set, like the colours above,
 * rather than an uploaded image. Every project then reads in the same visual
 * language as the rest of the interface, in both themes and on every
 * platform, and nothing has to be stored, resized or served as a file.
 *
 * The names are the interface's own; it maps each onto a drawing.
 */
export const PROJECT_ICONS = [
    'folder',
    'layers',
    'globe',
    'smartphone',
    'monitor',
    'server',
    'database',
    'cloud',
    'shield',
    'lock',
    'card',
    'wallet',
    'chart',
    'bot',
    'package',
    'beaker',
    'briefcase',
    'users',
    'settings',
    'sparkles',
];
/** What a project is given when nobody picks: a plain folder, no tint. */
export const DEFAULT_PROJECT_ICON = 'folder';
export const DEFAULT_PROJECT_ICON_COLOR = 'gray';
//# sourceMappingURL=enums.js.map